import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotShowsSection from './components/HotShowsSection';
import LatestArticlesSection from './components/LatestArticlesSection';
import FaqSection from './components/FaqSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <HotShowsSection />
        <LatestArticlesSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}